<template>

    <div>

        <MarginInput :options="options"
            :open="open"
        />

        <!--
            Block-level bg + text colour. Cross-referenced for WCAG AA
            contrast — picking a green bg greys out swatches in the text
            picker that wouldn't meet 4.5:1 against it (and vice versa)
            when `window.galaxyWcag` is true. The pair lives in its own
            `BackgroundAndTextColorInput` so loop-item panels can reuse
            the same logic without re-wiring the cross-reference.
        -->
        <BackgroundAndTextColorInput :options="options" />

        <AnchorInput :options="options"/>

    </div>

</template>

<script>

import AnchorInput from "./AnchorInput";
import MarginInput from "./MarginInput";
import BackgroundAndTextColorInput from "./BackgroundAndTextColorInput";

export default {

    components: {
        BackgroundAndTextColorInput,
        AnchorInput,
        MarginInput,
    },

    props: {
        options: Object,
        open: {
            type: Boolean,
            default: true,
        }
    },

}
</script>
